import { useCallback } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { useUserMenuDataShapes } from '../../../controllers/user-state/user-menu-data-shapes-provider';
import type { CustomizationModalProps } from '../../../ui/customization-modal/types';
import type { ExtendedUserMenuData, UserMenuData } from '../../types';

export const useOnSave = (): CustomizationModalProps['onSave'] => {
	const { setUserMenuDataAsync, setUserMenuDataSync } = useUserMenuDataShapes();

	return useCallback(
		async (
			updatedItemExtendedUserMenuData: ExtendedUserMenuData,
			updatedShortcutExtendedUserMenuData: ExtendedUserMenuData,
		) => {
			// Put the data back together and remove extra properties
			const userMenuData: UserMenuData = updatedItemExtendedUserMenuData
				.concat(updatedShortcutExtendedUserMenuData)
				.map(({ menuId, visible }) => ({ menuId, visible }));

			fg('navx-noissue-20250918-fix-types')
				? setUserMenuDataSync(userMenuData)
				: await setUserMenuDataAsync(userMenuData);
		},
		[setUserMenuDataAsync, setUserMenuDataSync],
	);
};
